module.exports = __webpack_public_path__ + "static/media/DOUBLE-BREASTED 4 BUTTONS.0b7b4c16.svg";